"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdoRepositoryType = void 0;
// All possible options are listed here: https://learn.microsoft.com/en-us/dotnet/api/microsoft.teamfoundation.build.webapi.repositorytypes?view=azure-devops-dotnet
// We mostly work with TfsGit repo type which corresponds to ADO repository.
var AdoRepositoryType;
exports.AdoRepositoryType = AdoRepositoryType;
(function (AdoRepositoryType) {
  AdoRepositoryType["TfsGit"] = "TfsGit";
  AdoRepositoryType["GitHub"] = "GitHub";
})(AdoRepositoryType || (exports.AdoRepositoryType = AdoRepositoryType = {}));